import type { TaskStatus } from './api';

/**
 * Core's `workState`, for the rows a screen draws: open, parked, done or dropped.
 *
 * The web cannot import `@planner/core`, so this is the second spelling of one rule, and
 * `test/unit/workState.spec.ts` evaluates both over every status so they cannot drift. The figures
 * a screen prints — `openWeight`, `parkedWeight`, `directTasksParked` — come from the server; this
 * decides only which *rows* sit under which of those figures, so the list and the number above it
 * classify a task the same way. Parked is never open: see `packages/core/src/domain/workState.ts`.
 */
export type WorkState = 'open' | 'parked' | 'done' | 'dropped';

export function workStateOf(task: { status: TaskStatus; completedAt: string | null }): WorkState {
  if (task.status === 'dropped') return 'dropped';
  if (task.completedAt !== null || task.status === 'done') return 'done';
  if (task.status === 'parked') return 'parked';
  return 'open';
}
